import { FlowComponent } from '../../flow.min.js';
import { tailwindSheet, baseStyles } from '../../_shared/styles.js';

const template = FlowComponent.html`
    <h1 class="text-4xl font-bold p-10">Hola</h1>
`;

export class FlowPanel extends FlowComponent {
    static get styles() { return [tailwindSheet, baseStyles]; }
    static get template() { return template; }
}

customElements.define('flow-panel', FlowPanel);
